import React from "react";
import { FaCaretDown } from "react-icons/fa";
import Select, { components } from "react-select";

import { EMPTY_STRING, COLOR } from "../../../constants";
import { customStyles } from "./CustomStyles";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <FaCaretDown color={COLOR.WHITE} />
    </components.DropdownIndicator>
  );
};

const ReactSelect = ({
  options,
  selectedOption,
  setSelectedOption,
  isMulti = false,
  name = EMPTY_STRING,
  placeholder = EMPTY_STRING,
}) => {
  return (
    <>
      <Select
        name={name}
        isClearable={false}
        isMulti={isMulti}
        options={options}
        value={selectedOption}
        getOptionLabel={(x) => x.name}
        getOptionValue={(x) => x.id}
        onChange={setSelectedOption}
        styles={customStyles()}
        placeholder={placeholder}
        components={{ DropdownIndicator }}
      />
    </>
  );
};

export default ReactSelect;
